module.exports = __webpack_public_path__ + "9e4d6b69468fbd7946083a32e48c70c0.png";